var coufigure, getCoufigureSize, loadCoufigures, preloadimages, stripUrl;

coufigure = function () {
  return loadCoufigures();
};

stripUrl = function (url) {
  var strippedUrl;
  strippedUrl = url
    .replace(/^(https?:|)\/\//, "")
    .replace("s3.amazonaws.com/endabowe", "endabowecdncdn.coucouapp.com/s3")
    .replace(
      "enda-bowe.s3.us-east-2.amazonaws.com",
      "endabowecdncdn.coucouapp.com/s3-raw"
    );
  return strippedUrl;
};

loadCoufigures = function () {
  $(".coufigure.fixed").each(function () {
    var $this, height, strippedUrl, url, width;
    $this = $(this);
    width = getCoufigureSize($(window).width());
    height = getCoufigureSize($(window).height());
    strippedUrl = stripUrl($this.data("src"));
    url =
      "//images.weserv.nl/?url=" + strippedUrl + "&w=" + width + "&h=" + height;
    $this.prepend(
      $("<img />").attr({
        src: url,
      })
    );
    return preloadimages([url]).done(function (images) {
      return $this.find("img").css("opacity", "1");
    });
  });
  $(".coufigure.height").each(function () {
    var $this, height, strippedUrl, url, width;
    $this = $(this);
    if ($(window).width() < 768) {
      width = getCoufigureSize($this.width());
      strippedUrl = stripUrl($this.data("src"));
      url = "//images.weserv.nl/?url=" + strippedUrl + "&w=" + width;
    } else {
      height = getCoufigureSize(500);
      strippedUrl = $this.data("src").replace(/^(https?:|)\/\//, "");
      url = "//images.weserv.nl/?url=" + strippedUrl + "&h=" + height;
    }
    $this.find("img").attr({
      src: url,
    });
    return preloadimages([url]).done(function (images) {
      return $this.find("img").css("opacity", "1");
    });
  });
  $(".coufigure.padded").each(function () {
    var $this, strippedUrl, url, width;
    $this = $(this);
    width = getCoufigureSize($this.width());
    strippedUrl = stripUrl($this.data("src"));
    url = "//images.weserv.nl/?url=" + strippedUrl + "&w=" + width;
    $this.prepend(
      $("<img class='coufigure-img' />").attr({
        src: url,
      })
    );
    return preloadimages([url]).done(function (images) {
      return $this.find("img").css("opacity", "1");
    });
  });
  $(".coufigure.unpadded").each(function () {
    var $this, height, strippedUrl, url, width;
    $this = $(this);
    height = getCoufigureSize($this.height());
    width = getCoufigureSize($this.width());
    strippedUrl = stripUrl($this.data("src"));
    url =
      "//images.weserv.nl/?url=" +
      strippedUrl +
      "&w=" +
      width +
      "&h=" +
      height +
      "&q=80";
    $this.prepend(
      $("<img class='coufigure-img' />").attr({
        src: url,
      })
    );
    return preloadimages([url]).done(function (images) {
      return $this.find("img").css("opacity", "1");
    });
  });
  return $(".coufigure-bg").each(function () {
    var $this, height, strippedUrl, url, width;
    $this = $(this);
    height = getCoufigureSize($this.height());
    width = getCoufigureSize($this.width());
    strippedUrl = stripUrl($this.data("src"));
    url =
      "//images.weserv.nl/?url=" +
      strippedUrl +
      "&w=" +
      width +
      "&h=" +
      height +
      "&q=80";
    $this.css("background-image", "url('" + url + "')");
    return preloadimages([url]).done(function (images) {
      return $this.css("opacity", "1");
    });
  });
};

getCoufigureSize = function (size) {
  var pixelRatio;
  if (typeof window.devicePixelRatio !== "undefined") {
    pixelRatio = window.devicePixelRatio;
  } else {
    pixelRatio = 1;
  }
  if (size % 100 === 0) {
    return size * pixelRatio;
  } else {
    return Math.round((size * pixelRatio + 50) / 100) * 100;
  }
};

preloadimages = function (arr) {
  var i, imageloadpost, loadedimages, newimages, postaction;
  imageloadpost = function () {
    loadedimages++;
    if (loadedimages === arr.length) {
      postaction(newimages);
    }
  };
  newimages = [];
  loadedimages = 0;
  postaction = function () {};
  arr = typeof arr !== "object" ? [arr] : arr;
  i = 0;
  while (i < arr.length) {
    newimages[i] = new Image();
    newimages[i].src = arr[i];
    newimages[i].onload = function () {
      imageloadpost();
    };
    newimages[i].onerror = function () {
      imageloadpost();
    };
    i++;
  }
  return {
    done: function (f) {
      postaction = f || postaction;
    },
  };
};

$(document).on("page:load", coufigure);

$(function () {
  return coufigure();
});

// ---
// generated by coffee-script 1.9.2
